var map = {
	"./ajax/ajax-page.ts": "./src/patterns/modules/ajax/ajax-page.ts",
	"./ajax/ajax.ts": "./src/patterns/modules/ajax/ajax.ts",
	"./application-steps/application-steps.ts": "./src/patterns/modules/application-steps/application-steps.ts",
	"./article-content/article-content.ts": "./src/patterns/modules/article-content/article-content.ts",
	"./article-grid/article-grid.ts": "./src/patterns/modules/article-grid/article-grid.ts",
	"./calculator-form/calculator-form.ts": "./src/patterns/modules/calculator-form/calculator-form.ts",
	"./calculator-steps/calculator-steps.ts": "./src/patterns/modules/calculator-steps/calculator-steps.ts",
	"./calculator/calculator.ts": "./src/patterns/modules/calculator/calculator.ts",
	"./career-grid/career-grid.ts": "./src/patterns/modules/career-grid/career-grid.ts",
	"./chess/chess.ts": "./src/patterns/modules/chess/chess.ts",
	"./content-1-1/content-1-1.ts": "./src/patterns/modules/content-1-1/content-1-1.ts",
	"./country-list/country-list.ts": "./src/patterns/modules/country-list/country-list.ts",
	"./cta/cta.ts": "./src/patterns/modules/cta/cta.ts",
	"./error404/error404.ts": "./src/patterns/modules/error404/error404.ts",
	"./footer-banner/footer-banner.ts": "./src/patterns/modules/footer-banner/footer-banner.ts",
	"./form/form.ts": "./src/patterns/modules/form/form.ts",
	"./hero/hero.ts": "./src/patterns/modules/hero/hero.ts",
	"./icon-list-simple/icon-list-simple.ts": "./src/patterns/modules/icon-list-simple/icon-list-simple.ts",
	"./icon-list/icon-list.ts": "./src/patterns/modules/icon-list/icon-list.ts",
	"./image-content/image-content.ts": "./src/patterns/modules/image-content/image-content.ts",
	"./image-module/image-module.ts": "./src/patterns/modules/image-module/image-module.ts",
	"./jobs/jobs.ts": "./src/patterns/modules/jobs/jobs.ts",
	"./logo-module/logo-module.ts": "./src/patterns/modules/logo-module/logo-module.ts",
	"./map-module/map-module.ts": "./src/patterns/modules/map-module/map-module.ts",
	"./offer-content/offer-content.ts": "./src/patterns/modules/offer-content/offer-content.ts",
	"./offers-grid/offers-grid.ts": "./src/patterns/modules/offers-grid/offers-grid.ts",
	"./offers/offers.ts": "./src/patterns/modules/offers/offers.ts",
	"./packages/packages.ts": "./src/patterns/modules/packages/packages.ts",
	"./password-form/password-form.ts": "./src/patterns/modules/password-form/password-form.ts",
	"./products-grid/products-grid.ts": "./src/patterns/modules/products-grid/products-grid.ts",
	"./statistics/statistics.ts": "./src/patterns/modules/statistics/statistics.ts",
	"./steps/steps.ts": "./src/patterns/modules/steps/steps.ts",
	"./stories/stories.ts": "./src/patterns/modules/stories/stories.ts",
	"./tabbed-accordion/tabbed-accordion.ts": "./src/patterns/modules/tabbed-accordion/tabbed-accordion.ts",
	"./table/table.ts": "./src/patterns/modules/table/table.ts",
	"./team/team-grid.ts": "./src/patterns/modules/team/team-grid.ts",
	"./testimonials/testimonials.ts": "./src/patterns/modules/testimonials/testimonials.ts",
	"./tpl-calculator/tpl-calculator.ts": "./src/patterns/modules/tpl-calculator/tpl-calculator.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/patterns/modules sync recursive ^\\.\\/.*(?<%21--example)\\.ts$";